// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4b691a1e","453":"3f86dffc","732":"d1a30cad","977":"9148aa30"}[chunkId] + ".chunk.js";
};